export function formatDate(date: any, format: string = 'Y-m-d') {
    let monthNumbers: any = {
        0: '01',
        1: '02',
        2: '03',
        3: '04',
        4: '05',
        5: '06',
        6: '07',
        7: '08',
        8: '09',
        9: '10',
        10: '11',
        11: '12'
    };
    switch (format) {
        case 'Y-m-d':
            date = new Date(date);
            return date.getFullYear() + '-' + monthNumbers[date.getMonth()] + '-' + date.getDate().toString().padStart(2, "0");
            break;
        case 'd/m/Y':
            date = new Date(date);
            return date.getDate().toString().padStart(2, "0") + '/' + monthNumbers[date.getMonth()] + '/' + date.getFullYear();
            break;
        case 'Y-m-d H:i:s':
            date = new Date(date);
            return date.getFullYear() + '-' + monthNumbers[date.getMonth()] + '-' + date.getDate().toString().padStart(2, "0") + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            break;
        case 'yyyy':
            date = new Date(date);
            return date.getFullYear();
    }
}

export function formatTime(date: any, format: string = 'H:i:s') {
    let monthNumbers: any = {
        0: '01',
        1: '02',
        2: '03',
        3: '04',
        4: '05',
        5: '06',
        6: '07',
        7: '08',
        8: '09',
        9: '10',
        10: '11',
        11: '12'
    };
    switch (format) {
        case 'H:i:s':
            date = new Date(date);
            return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            break;
        case 'yyyy':
            date = new Date(date);
            return date.getFullYear();
    }
}

export function formatCurrency(amount: any) {
    // Convert number to string and split into parts before and after decimal point
    let parts = amount.toString().split(".");
    
    // Add commas for thousands separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    // Add Indian Rupee symbol (₹) and join the parts
    return parts.join(".");
}

export function isEmailAllowed(email: string): boolean {
    const allowedEmails = process.env.REACT_APP_ALLOWED_EMAILS || '';
    if (!allowedEmails) {
        return false;
    }
    const emailList = allowedEmails.split(',').map(e => e.trim().toLowerCase());
    return emailList.includes(email.toLowerCase());
}
